import { useTheme } from '@emotion/react'
import { IconButton } from '@mui/material'
import React from 'react'
import { Secondary } from 'ui-components/Buttons'
import { ReactComponent as InfoIcon } from 'assets/help-circle.svg';

const NeedHelpButton = ({
    title
}) => {
    const theme = useTheme()
    return (
        <>
            <a href="mailto:support@backrr.com">
                <Secondary
                    sx={{
                        fontSize: "14px",
                        padding: "8px 18px",
                        display: { xs: "none", md: 'inline-block' },
                    }}
                    onClick={() => { }}
                >

                    {title ? title : "Need help?"}
                </Secondary>
                <IconButton sx={{ display: { xs: "inline-block", md: 'none' }, padding: '5px' }}>
                    <InfoIcon style={{ width: '1.5rem', height: '1.5rem', display: 'flex', alignItems: 'center', gap: "4px", marginBlock: 'auto', stroke: '#000' }} />
                </IconButton>
            </a>
        </>
    )
}

export default NeedHelpButton